import {
  Table,
  Tr,
  Td,
  Tbody,
  Thead,
  Th,
  TableContainer,
  HStack,
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { useStores } from '../store/store_context';
import { useEffect, useRef, useState } from 'react';
import RoleModal from './role_modal';
import RoleEditForm from './role_forms/role_edit_form';
import { deleteRoleById, updateRoleById } from '../store/api_funcs';

// import UserModal from './user_modal';
// import UserEditForm from './user_forms/user_edit_form';
// import { updateUserById } from '../store/api_funcs';
import { VscCheck } from 'react-icons/vsc';
import { VscClose } from 'react-icons/vsc';
import { MdDelete } from 'react-icons/md';

const CheckIcon = ({ enabled }) =>
  enabled == 1 ? <VscCheck color="#22C55E" /> : <VscClose color="#EF4444" />;

const RoleTable = ({ getTableRoles, roles }) => {
  const { pageStore } = useStores();
  const [roleToDelete, setRoleToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef();
  const toast = useToast();
  const tableContainerProps = {
    width: '100%',
    border: '1px solid rgba(255,255,255,0.14)',
    borderRadius: '8px',
    backgroundColor: 'rgba(255,255,255,0.025)',
    overflow: 'hidden',
  };
  const rowProps = {
    borderBottom: '1px solid rgba(255,255,255,0.08)',
    _hover: { backgroundColor: 'rgba(139,92,246,0.18)' },
  };
  const cellProps = {
    borderRight: '1px solid rgba(255,255,255,0.08)',
  };

  const requestDelete = role_id => {
    setRoleToDelete(role_id);
    onOpen();
  };

  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      await deleteRoleById(roleToDelete, pageStore.token);
      await getTableRoles();
      toast({
        title: 'Роль удалена',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      onClose();
    } catch (error) {
      toast({
        title: 'Не удалось удалить роль',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsDeleting(false);
    }
  };

  const roleTableText = {
    RU: [
      'роль',
      'просмотр всех панелей',
      'добавление панелей',
      'обновление прошивки',
      'просмотр всех пользователей',
      'добавление пользователей',
      'редактирование тем',
      'получение отчетов',
      'мониторинг',
      'команды',
      'настройки мониторинга',
      'ремонтная консоль',
    ],
    EN: [
      'role name',
      'see all panels',
      'add panels',
      'update firmware',
      'see all users',
      'add users',
      'edit themes',
      'get errors',
      'monitoring',
      'commands',
      'monitoring settings',
      'repair console',
    ],
  };
  useEffect(() => {
    getTableRoles();
  }, []);
  // useEffect(() => {
  //   console.log(users);
  // }, [users]);
  return (
    <>
      <TableContainer {...tableContainerProps}>
        <Table variant={'unstyled'}>
          <Thead>
            <Tr>
              <Th>{roleTableText[pageStore.lang][0]}</Th>
              <Th>{roleTableText[pageStore.lang][1]}</Th>
              <Th>{roleTableText[pageStore.lang][2]}</Th>
              <Th>{roleTableText[pageStore.lang][3]}</Th>
              <Th>{roleTableText[pageStore.lang][4]}</Th>
              <Th>{roleTableText[pageStore.lang][5]}</Th>
              <Th>{roleTableText[pageStore.lang][6]}</Th>
              <Th>{roleTableText[pageStore.lang][7]}</Th>
              <Th>{roleTableText[pageStore.lang][8]}</Th>
              <Th>{roleTableText[pageStore.lang][9]}</Th>
              <Th>{roleTableText[pageStore.lang][10]}</Th>
              <Th>{roleTableText[pageStore.lang][11]}</Th>
              <Th>Действия</Th>
            </Tr>
          </Thead>
          <Tbody>
            {roles !== null
              ? roles.map(elem => {
                  return (
                    <Tr key={elem.role_id} {...rowProps}>
                      <Td {...cellProps}>
                        {elem.role_name}
                      </Td>
                      <Td {...cellProps}>
                        <CheckIcon enabled={elem.see_all_panels} />
                      </Td>
                      <Td {...cellProps}>
                        <CheckIcon enabled={elem.add_panels} />
                      </Td>
                      <Td {...cellProps}>
                        <CheckIcon enabled={elem.update_firmware} />
                      </Td>
                      <Td {...cellProps}>
                        <CheckIcon enabled={elem.see_all_users} />
                      </Td>
                      <Td {...cellProps}>
                        <CheckIcon enabled={elem.add_users} />
                      </Td>
                      <Td {...cellProps}>
                        <CheckIcon enabled={elem.edit_themes} />
                      </Td>
                      <Td {...cellProps}>
                        <CheckIcon enabled={elem.get_errors} />
                      </Td>
                      <Td {...cellProps}>
                        <CheckIcon enabled={elem.monitoring_view} />
                      </Td>
                      <Td {...cellProps}>
                        <CheckIcon enabled={elem.monitoring_control} />
                      </Td>
                      <Td {...cellProps}>
                        <CheckIcon enabled={elem.monitoring_settings} />
                      </Td>
                      <Td {...cellProps}>
                        <CheckIcon enabled={elem.repair_console_access} />
                      </Td>
                      <Td {...cellProps}>
                        <HStack>
                          <RoleModal>
                            <RoleEditForm
                              role_id={elem.role_id}
                              onSubmit={updateRoleById}
                              updateRolesTable={getTableRoles}
                            />
                          </RoleModal>
                          <Button
                            aria-label="Удалить роль"
                            backgroundColor={'rgba(239,68,68,0.86)'}
                            color="white"
                            _hover={{ backgroundColor: '#E05A5A' }}
                            onClick={() => requestDelete(elem.role_id)}
                          >
                            <MdDelete />
                          </Button>
                        </HStack>
                      </Td>
                    </Tr>
                  );
                })
              : null}
          </Tbody>
        </Table>
      </TableContainer>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent
            fontFamily={"'Jura', sans-serif"}
            backgroundColor={'#1b1c2b'}
            color={'white'}
          >
            <AlertDialogHeader>Удалить роль?</AlertDialogHeader>
            <AlertDialogBody>Действие нельзя отменить.</AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Отмена
              </Button>
              <Button
                ml={3}
                colorScheme="red"
                isLoading={isDeleting}
                onClick={handleDelete}
              >
                Удалить
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default RoleTable;
